import React from 'react'

const Binary = () => {
    return (
        <div className='container'>
            <h1>Binary Search In C</h1>
           
         <p>   A Binary Search is a sorting algorithm, that is used to search an element in 
             a sorted array. A binary search technique works only on a sorted array, so an 
              array must be sorted to apply binary search on the array. It is a searching 
              technique that is better then the liner search technique as the number of 
              iterations decreases in the binary search. <br /> <br /> <br />

The logic behind the binary search is that there is a key. This key holds the
 value to be searched. The highest and the lowest value are added and divided by 2
 . Highest and lowest and the first and last element in the array. The mid value is
  then compared with the key. If mid is equal to the key, then we get the output 
  directly. Else if the key is greater then mid then the mid+1 becomes the lowest
   value and the process is repeated on the shortened array. Else if the key value 
   is less then mid, mid-1 becomes the highest value and the process is repeated on 
   the shortened array. If it is not found anywhere, an error message is displayed.
          </p>  
            <div className='containers'>
           <code className='library'> #include</code> &lt;stdio.h&gt; <br/>
           <code className='keywords'>int main()</code><br/>
&#123; <br/>
<code className='keywords'>int</code> i, low, high, mid, n, key, array[100];<br/>
<code className='library'>printf</code>("Enter number of elementsn");<br/><br/>
<code className='library'>scanf</code>("%d",&n);<br/>
<code className='library'>printf</code>("Enter %d integersn", n);<br/>
<code className='keywords'>for</code>(i = 0; i &lt; n; i++)<br/>
<code className='library'>scanf</code>("%d",&array[i]);<br/>
<code className='library'>printf</code>("Enter value to findn");<br/>
<code className='library'>scanf</code>("%d", &key);<br/>
low = 0;<br/>
high = n - 1;<br/>
mid = (low+high)/2;<br/>
<code className='keywords'>while</code> (low &lt;= high) &#123; <br/>
<code className='keywords'>if</code>(array[mid] &lt; key)<br/>
low = mid + 1;<br/>
<code className='keywords'>else if</code> (array[mid] == key) &#123; <br/><br/>
<code className='library'>printf</code>("%d found at location %d.n", key, mid+1);<br/>
<code className='library'>break;</code><br/>
&#125;<br/>
<code className='keywords'>else</code><br/>
high = mid - 1;<br/>
mid = (low + high)/2;<br/>
&#125;<br/>
<code className='keywords'>if</code>(low &gt; high)<br/>
<code className='library'>printf</code>("Not found! %d isn't present in the list.n", key);<br/>
<code className='library'>return</code> 0;
&#125;
            </div>
        </div>
    )
}

export default Binary
